import { authService } from '../../../service/auth-service'
import { logger } from '../../../util/logger'
import { ErrorMessageHint } from '../../util/error-message-hint'
import { PasswordToggle } from '../../util/password-toggle'
import { OverlaySpinner } from '../../util/spinner/overlay-spinner'
import style from './create.module.scss'
import { passwordService } from '@grndhouse/react-common'
import { yupResolver } from '@hookform/resolvers/yup'
import React, { useState } from 'react'
import { Button, Form } from 'react-bootstrap'
import { useForm } from 'react-hook-form'
import { useHistory } from 'react-router-dom'
import * as yup from 'yup'

const setInitialPasswordSchema = yup
  .object()
  .shape({
    password: passwordService.passwordValidationObject,
    confirmPassword: yup
      .string()
      .oneOf([yup.ref('password'), null], 'Your passwords do not match. Please try again.')
      .required('Confirm password is required.'),
  })
  .required()

type FormValues = {
  password: string
  confirmPassword: string
}

export const SetPasswordStep = (): React.ReactElement => {
  const [isLoading, setIsLoading] = useState(false)
  const [errorMessage, setErrorMessage] = useState<string>()
  const [passwordVisible, setPasswordVisible] = useState(false)
  const history = useHistory()

  const {
    register,
    handleSubmit,
    formState: { errors, isValid },
  } = useForm<FormValues>({
    resolver: yupResolver(setInitialPasswordSchema),
    mode: 'all',
  })

  const onSubmit = async (data: FormValues): Promise<void> => {
    try {
      if (setIsLoading) setIsLoading(true)
      setErrorMessage(undefined)
      const { password } = data
      await authService.setInitialPassword({ password })
      history.push(`/create-account/set-name`)
    } catch (err) {
      logger.error(err)
      setErrorMessage(err.message)
    } finally {
      if (setIsLoading) setIsLoading(false)
    }
  }

  return (
    <>
      <Form onSubmit={handleSubmit(onSubmit)}>
        <h1 className="text-center">Enter your password</h1>
        <Form.Group className={style.inputContainerGroup}>
          <Form.Group>
            <PasswordToggle onToggle={setPasswordVisible} isVisible={passwordVisible}>
              <Form.Control
                type={passwordVisible ? 'text' : 'password'}
                placeholder="Password"
                {...register('password')}
                className={`form-control ${errors.password ? 'is-invalid' : ''}`}
              />
              <Form.Control.Feedback type="invalid">{errors.password && <p>{errors.password.message}</p>}</Form.Control.Feedback>
            </PasswordToggle>
          </Form.Group>
          <Form.Group>
            <PasswordToggle onToggle={setPasswordVisible} isVisible={passwordVisible}>
              <Form.Control
                type={passwordVisible ? 'text' : 'password'}
                placeholder="Confirm password"
                {...register('confirmPassword')}
                className={`form-control ${errors.confirmPassword ? 'is-invalid' : ''}`}
              />
              <Form.Control.Feedback type="invalid">
                {errors.confirmPassword && <p>{errors.confirmPassword.message}</p>}
              </Form.Control.Feedback>
            </PasswordToggle>
          </Form.Group>
          <small>
            Your password must contain at least one uppercase letter, and include at least one number and one special character.
          </small>
          <ErrorMessageHint message={errorMessage} />
        </Form.Group>
        <Form.Group className="form-group">
          <Button type="submit" className="w-100" disabled={!isValid || isLoading}>
            Continue
          </Button>
        </Form.Group>
      </Form>
      {isLoading && <OverlaySpinner />}
    </>
  )
}
